// removed by extract-text-webpack-plugin
module.exports = {"Home":"Home___1Wtnb","p":"p____J9p7","link":"link___1-NEH","img":"img___3hVIY","aaron":"aaron___UrX8G"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Home/style.scss
// module id = 118
// module chunks = 0